"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildXHRRequest = void 0;
const buildXHRRequest = (dataLayerDataUrl) => `
var req = new XMLHttpRequest();
req.open("GET", "${dataLayerDataUrl}", true);
req.responseType = "text";
req.addEventListener("readystatechange", function(event) {
  if (event.target.readyState === 4 && event.target.status === 200) {
    try {
      var data = JSON.parse(event.target && event.target.responseText);
      window.dataLayer.push(data);
    } catch (e) {
      console.error("no gtm data available", e);
    }
  }
});
req.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
req.send();
`;
exports.buildXHRRequest = buildXHRRequest;
//# sourceMappingURL=build.xhr.request.js.map